// extracted by mini-css-extract-plugin
module.exports = {"form":"delete-product_form__20Mn5","form__header":"delete-product_form__header__9W2QP"};